<template>
  <div class="form-group input-label">
    <label for="nombre">{{ label }}</label>
    <div class="d-flex align-items-center">
      <input
        type="text"
        id="day"
        class="form-control width-date"
        placeholder="DD"
        @change="getDayInitialDate('1', initialDates.day)"
        v-model="$v.initialDates.day.$model"
        @blur="
          $v.initialDates.day.$touch(),
            verifyNumber('1', initialDates.day)
        "
        :class="{ error: $v.initialDates.day.$error }"
      />
      <input
        type="text"
        id="month"
        class="form-control width-date"
        placeholder="MM"
        @change="getDayInitialDate('2', initialDates.month)"
        v-model="$v.initialDates.month.$model"
        @blur="
          $v.initialDates.month.$touch(),
            verifyNumber('2', initialDates.month)
        "
        :class="{ error: $v.initialDates.month.$error }"
      />
      <input
        type="text"
        id="year"
        class="form-control width-date-year"
        placeholder="AAAA"
        @change="getDayInitialDate('3', initialDates.year)"
        v-model="$v.initialDates.year.$model"
        @blur="
          $v.initialDates.year.$touch(),
            verifyNumber('3', initialDates.year)
        "
        :class="{ error: $v.initialDates.year.$error }"
      />
      <date-picker
        class="inline-block h-full"
        v-model="_value"
        :attributes="attrs"
        :model-config="modelConfig"
        @input="getInitialDate"
      >
        <template v-slot="{ inputValue, togglePopover }">
          <div class="flex items-center">
            <button class="btn-icon-calendar" @click="togglePopover()">
              <b-icon icon="calendar-week"></b-icon>
            </button>
            <input hidden :value="inputValue" readonly />
          </div>
        </template>
      </date-picker>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from 'vuelidate/lib/validators'

export default {
  name: 'InputDatePicker',
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      initialDate: null,
      initialDates: {
        day: null,
        month: null,
        year: null,
      },
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      attrs: [
        {
          highlight: 'blue',
          dates: new Date(),
        },
      ],
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('update:value', value)
        this.$emit('input', value)
      }
    }
  },
  validations: {
    initialDates: {
      day: {
        required,
        numeric,
        minLength: minLength(1),
        maxLength: maxLength(2),
      },
      month: {
        required,
        numeric,
        minLength: minLength(1),
        maxLength: maxLength(2),
      },
      year: {
        required,
        numeric,
        minLength: minLength(4),
        maxLength: maxLength(4),
      },
    },
  },
  methods: {
    getInitialDate(date) {
      const me = this
      const date1 = date.split('-')
      me.initialDates.year = date1[0]
      me.initialDates.month = date1[1]
      me.initialDates.day = date1[2]
    },
    getDayInitialDate(type, value) {
      const me = this

      if (type == '1') {
        me.validateNumber(type, value)
      } else if (type == '2') {
        me.validateNumber(type, value)
      } else {
        me.validateNumber(type, value)
      }

      if (!me.$v.initialDates.$invalid) {
        me.initialDate = `${
          me.initialDates.year
        }-${me.initialDates.month}-${me.initialDates.day}`
        me._value = me.initialDate;
      }
    },
    validateNumber(type, value) {
      const me = this
      if (type == '1') {
        if (
          (Number(value) !== null && Number(value) < 0) ||
          Number(value) > 31 ||
          (value.length > 1 && Number(value) == 0) ||
          isNaN(value)
        )
          me.initialDates.day = null
      } else if (type == '2') {
        if (
          (Number(value) !== null && Number(value) < 0) ||
          Number(value) > 12 ||
          (value.length > 1 && Number(value) == 0) ||
          isNaN(value)
        )
          me.initialDates.month = null
      } else {
        if (
          (Number(value) !== null && Number(value) < 0) ||
          Number(value) > 9999 ||
          (value.length > 1 && Number(value) == 0) ||
          isNaN(value)
        )
          me.initialDates.year = null
      }
    },
    verifyNumber(type, value) {
      const me = this
      if (type == '1') {
        if (value && value.length > 0 && Number(value == 0))
          me.initialDates.day = null
      } else if (type == '2') {
        if (value && value.length > 0 && Number(value == 0))
          me.initialDates.month = null
      } else {
        if (value && value.length > 0 && Number(value == 0))
          me.initialDates.year = null
      }
    },
  },
  mounted() {
    const me = this;
    if (me.value) me.getInitialDate(me.value);
  }
}
</script>
<style lang="scss">
.form-group-datepicker {
  .btn-secondary {
    border-color: #598fbd;
    background-color: white;
  }
  .show .btn-secondary {
    background-color: rgb(240, 240, 240);
    border-color: #598fbd;
  }
}
</style>
